'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'eventHeroVideo', () => ({

		started: false,
		playing: false,
		controlsVisible: false,
		idleTimer: null,

		play() {
			this.started = true;

			this.$nextTick( () => {
				if ( this.$refs.video ) this.$refs.video.play();
			});
		},

		togglePlayPause() {
			const video = this.$refs.video;

			if ( ! video ) return;

			if ( video.paused ) {
				video.play();
			} else {
				video.pause();
			}
		},

		onPlay() {
			this.playing = true;
			this.controlsVisible = false;
			this.clearIdleTimer();
		},

		onPause() {
			this.playing = false;
			this.clearIdleTimer();
		},

		handleMouseMove() {
			if ( ! this.playing ) return;

			this.controlsVisible = true;
			this.clearIdleTimer();

			this.idleTimer = setTimeout( () => {
				this.controlsVisible = false;
			}, 2500 );
		},

		clearIdleTimer() {
			if ( this.idleTimer ) {
				clearTimeout( this.idleTimer );
				this.idleTimer = null;
			}
		},
	}) );
});
